import React, { useEffect, useState } from "react";
import { MdHistory } from "react-icons/md";
import { getSubadminTransactionsApi } from "../../ApiCalls/Revenue";

const TransactionHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await getSubadminTransactionsApi();
        setTransactions(response?.data?.data || []);
      } catch (error) {
        console.error("Failed to fetch transactions", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  return (
    <div className="p-6 space-y-8 min-h-screen">
      <div className="flex items-center space-x-2 mb-6">
        <MdHistory className="text-3xl text-gray-700" />
        <h1 className="text-2xl font-bold text-gray-800">
          Transaction History
        </h1>
      </div>

      {/* Transactions Section */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gray-50">
          <h2 className="text-lg font-bold text-gray-800">
            All Transactions
          </h2>

          <div className="flex gap-2">
            <input
              type="date"
              className="border rounded px-2 py-1 text-sm text-gray-600 focus:outline-brand-primary"
            />
            <button className="bg-brand-primary text-white px-3 py-1 rounded text-sm hover:bg-green-700 transition">
              Filter
            </button>
          </div>
        </div>

        {/* Loading State */}
        {loading && (
          <p className="text-center py-6 text-gray-500">
            Loading transactions...
          </p>
        )}

        {/* Empty State */}
        {!loading && transactions.length === 0 && (
          <p className="text-center py-6 text-gray-500">
            No transactions found
          </p>
        )}

        {!loading && transactions.length > 0 && (
          <div className="overflow-x-auto">
            <table className="min-w-full text-left text-sm whitespace-nowrap">
              <thead className="bg-gray-100 text-gray-600 uppercase text-xs font-bold leading-normal">
                <tr>
                  <th className="px-6 py-3">Date</th>
                  <th className="px-6 py-3">Description</th>
                  <th className="px-6 py-3">Type</th>
                  <th className="px-6 py-3 text-right">Amount</th>
                </tr>
              </thead>

              <tbody className="text-gray-600 text-sm font-light">
                {transactions.map((txn, index) => {
                  const amount = Number(txn.amount || 0);
                  const type =
                    amount >= 0
                      ? "credit"
                      : "debit";

                  return (
                    <tr
                      key={index}
                      className="border-b border-gray-200 hover:bg-gray-50"
                    >
                      <td className="px-6 py-3">
                        {txn.date || txn.created_at || "-"}
                      </td>

                      <td className="px-6 py-3 font-medium">
                        {txn.description ||
                          txn.remarks ||
                          "Transaction"}
                      </td>

                      <td className="px-6 py-3">
                        <span
                          className={`px-2 py-1 rounded text-xs uppercase font-semibold ${
                            type === "credit"
                              ? "bg-green-200 text-green-800"
                              : "bg-red-200 text-red-800"
                          }`}
                        >
                          {type}
                        </span>
                      </td>

                      <td
                        className={`px-6 py-3 text-right font-bold ${
                          amount >= 0
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                      >
                        {amount >= 0 ? "+" : ""}₹
                        {Math.abs(amount).toFixed(2)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination Footer */}
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-between items-center text-sm text-gray-600">
          <div>
  {transactions.length > 0 
    ? `Showing 1 to ${transactions.length} of ${transactions.length} entries` 
    : "Showing 0 entries"}
</div>

          <div className="flex gap-2">
            <button
              className="px-3 py-1 border rounded bg-white disabled:opacity-50"
              disabled
            >
              Previous
            </button>
            <button
              className="px-3 py-1 border rounded bg-white disabled:opacity-50"
              disabled
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionHistory;
